import OpportunityMetadata from './OpportunityMetadata.component';

export default OpportunityMetadata;